<template>
  <div :class="$style.container">
    <BarChart :height="280" :chartData="chartData" :options="options"/>
  </div>
</template>

<style lang="scss" module>
  .container {
    height: 280px;
  }
</style >

<script>
  import BarChart from '../../charts/BarChart';
import {mapState} from 'vuex'

  export default {
    props: ['data', 'maxY'],
    data: function() {
      return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            ticks: {
              min: 0,
              max: this.maxY,
            },
            stacked: true
          }]
        }
      }
    }},
    computed: {
      ...mapState([
        'workers',
      ]),
      chartData() {

        const total = Object.keys(this.workers).length;
        const partials = {
          'journeyman': [],
          'apprentice': [],
          'other': []
        }
        const colors = {
          'apprentice': '#00BBF1',
          'journeyman': '#009765',
          'other': '#ccc'
        }
        for (let i in this.data) {
          let apprentice = Math.floor(this.data[i].value * total / 100);
          let journeyman = Math.floor((100 - this.data[i].value) * total / 100);
          let other = total - apprentice - journeyman;
          partials.apprentice.push(apprentice);
          partials.journeyman.push(journeyman);
          partials.other.push(other);
        }

        const datasets = Object.keys(partials).map(type => {
          return {
            label: type.charAt(0).toUpperCase() + type.slice(1),
            backgroundColor: colors[type],
            data: partials[type]
          }
        });

        return {
          labels: Object.keys(this.data),
          datasets: datasets 
        };
      },
    },
    components: {
      BarChart
    },
  }
</script>
